import { render } from "./view_template.vue?vue&type=template&id=37ca2f51&scoped=true"
import script from "./viewTemplateComponent.js?vue&type=script&lang=js"
export * from "./viewTemplateComponent.js?vue&type=script&lang=js"

import "./view_template.vue?vue&type=style&index=0&id=37ca2f51&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ca2f51"]])

export default __exports__